import { useMutation, useQueryClient } from '@tanstack/react-query';

import { normalizeAccess } from '../../../domain/access';
import type { InviteMemberBody } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/** `POST /v1/invitation/invite` — envoie une invitation avec ses rôles et périmètres (204). */
export const useInviteMember = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: InviteMemberBody) =>
      getExtranetApi().post<InviteMemberBody, void>('/v1/invitation/invite', {
        ...body,
        access: normalizeAccess(body.access),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: extranetQueryKeys.invitations.root() });
    },
  });
};
